// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1B_5S","actionsCol":"EnrolledClinics_actionsCol__3LEPS"};